import { toirMapissuesConfigDefault } from '@infotech/toir-4sides-front-core'
import mapissuesConfig, { moduleCrudConfig as createModuleCrudConfig } from '@infotech/mapissues'
import {
  getFormConfig,
  getFilterConfig,
  getViewConfig,
  getGridConfig,
  getAllColumns,
  getAllFilters,
  defaultViewList,
  defaultFilterList,
} from './fieldsConf'

const { toirModuleConfig } = toirMapissuesConfigDefault.config


export const moduleConfig = {
  ...toirModuleConfig,
  getGridConfig,
  getViewConfig,
  getFormConfig,
  defaultViewList,
  routing: {
    ...toirModuleConfig.routing,
    list: {
      ...toirModuleConfig.routing.list,
      getAllColumns,
      filter: {
        ...toirModuleConfig.routing.list.filter,
        getAllFilters,
        getFilterConfig,
        defaultFilterList,
      },
    },
    read: {
      ...toirModuleConfig.routing.read,
      bottomWidgets: [
        ...toirModuleConfig.routing.read.bottomWidgets,
      ],
    },
  },
}

export const moduleCrudConfig = createModuleCrudConfig(moduleConfig)

export const CRUDRoute = () => mapissuesConfig.CRUDRoute(moduleCrudConfig)
